import type { JSX } from 'react';
import classNames from 'classnames';
import { Stack, Text, Title } from '@mantine/core';
import type { ICardHeaderProps } from './types';
import classes from './Card.module.css';

function CardHeader({
  title,
  subtitle,
  textColor,
  className,
}: Readonly<ICardHeaderProps>): JSX.Element {
  return (
    <Stack gap="xs" className={classNames(classes.header, className)}>
      <Title order={5} c={textColor}>
        {title}
      </Title>
      {subtitle && (
        <Text size="xs" c={textColor === 'dimmed' ? 'dimmed' : 'primary.4'}>
          {subtitle}
        </Text>
      )}
    </Stack>
  );
}

export default CardHeader;
